import { Injectable } from '@angular/core'

import * as loaderActions from '../+state/loader.actions'
import { LoaderFacade } from '../+state/loader.facade'

@Injectable({
  providedIn: 'root',
})
export class GbLoaderService {
  constructor(private loaderFacade: LoaderFacade) {}

  /**
   * Add item to actions in progress
   * @param id
   */
  setLoading(id: string) {
    this.loaderFacade.dispatch(loaderActions.setLoading({ id }))
  }

  /**
   * Remove item from actions in progress
   * @param id
   */
  setLoadingComplete(id: string) {
    this.loaderFacade.dispatch(loaderActions.setLoadingComplete({ id }))
  }

  /**
   * Add item to actions in progress and open loading spinner in dialog
   * @param id
   * @param label
   */
  showLoaderDialog(id: string, label?: string) {
    this.setLoading(id)
    this.loaderFacade.dispatch(loaderActions.showLoaderDialog({ id, label }))
  }

  /**
   * Remove item from actions in progress and close loading spinner dialog
   * @param id
   * @param label
   */
  hideLoaderDialog(id: string) {
    this.setLoadingComplete(id)
    this.loaderFacade.dispatch(loaderActions.hideLoaderDialog({ id }))
  }
}
